import { conditionalOperators } from 'shared/constants';
import { Severity, SeverityFormField } from 'shared/types';

export const parseConditionalSeverity = (
  severity: Severity,
  errorIf?: string,
  warnIf?: string,
) => {
  const severityFormField: SeverityFormField = {
    type: severity.toLowerCase() as Severity,
  };

  if (!errorIf && !warnIf) {
    return severityFormField;
  }

  const sortedOperators = [...conditionalOperators].sort(
    (a, b) => b.length - a.length,
  );

  const errorOperator = sortedOperators.find((op) => errorIf?.includes(op));

  const warnOperator = sortedOperators.find((op) => warnIf?.includes(op));

  if (errorOperator) {
    severityFormField.conditionalError = {
      operator: errorOperator,
      value: Number(errorIf?.replace(errorOperator, '').trim()),
    };
  }

  if (warnOperator) {
    severityFormField.conditionalWarning = {
      operator: warnOperator,
      value: Number(warnIf?.replace(warnOperator, '').trim()),
    };
  }

  return severityFormField;
};
